import React, { PropTypes } from 'react';
import { Paper } from 'material-ui';

const GrowNetwork = ({ containerStyle, networkLocation, history }) => {
  return (
    <Paper style={ Object.assign({}, containerStyle, { padding: '10px 50px', textAlign: 'center' }) }>
      <h4 style={{ marginBottom: '5px' }}>You've found a network we are still growing.</h4>
      <p>Help it grow faster by inviting your <a style={{ cursor: 'pointer' }} onTouchTap={() => history.push('/connections/add-connections')}>existing partners {`in ${networkLocation}.`}</a></p>
    </Paper>
  );
};

GrowNetwork.propTypes = {
  containerStyle: PropTypes.object,
  networkLocation: PropTypes.string,
  history: PropTypes.object.isRequired,
};

export default GrowNetwork;



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/grow-network.jsx